import React from "react";
import {cx} from "../../lib/ClassSet";
import "./DeliveryItem.css";
import ContextMenuTrigger from "../../components/ContextMenuTrigger";
import format from 'date-fns/format'

const DeliveryItem = (props) => {

  let {data} = props;

  let showWarning = false;
  let status = data.get("status");
  if (data.get("scheduleStatus") === "failed") {
    status = "Scheduling Failed";
    showWarning = true;
  }
  if (data.get("stockStatus") === "failed") {
    status = "Stock Failed";
    showWarning = true;
  }

  let prepDate = format(data.get("prepDate"), "MMM D, YYYY");
  if (data.get("scheduleStatus") !== "scheduled") {
    prepDate = "n/a";
  }
  if (data.get("scheduleStatus") === "preliminary") {
    prepDate = `${format(data.get("prepDate"), "MMM D, YYYY")}*`;
  }

  let warehouse = data.get("warehouseId");
  if (data.get("stockStatus") !== "reserved") {
    warehouse = "n/a";
  }

  let deliveryDate = `${format(data.get("requestedDeliveryDate"), "MMM D, YYYY")}*`;
  let deliveryDateHelp = "Delivery date is preliminary and shows date requested by customer.";
  if (data.get("scheduleStatus") === "scheduled") {
    deliveryDate = format(data.get("deliveryDate"), "MMM D, YYYY");
    deliveryDateHelp = "";
    if (data.get("requestedDeliveryDate") !== data.get("deliveryDate")) {
      deliveryDate = `${deliveryDate}±`;
      deliveryDateHelp = `The requested delivery date from the customer ${format(data.get("requestedDeliveryDate"), "MMM D, YYYY")} cannot be fulfilled.`;
    }
  }

  let classes = cx({
    "item": true,
    "subscription-delivery-list-item": true,
    "u-warning": showWarning,
    "u-selected": props.selected
  })

  let idClickFn = (e) => {
    props.onClick(data, e, "id")
  }

  let contextClickFn = (x, y) => props.onContextMenuClick(data, x, y)

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id"><span onClick={idClickFn}>{data.get("deliveryId")}</span></td>
      <td className="field f-recipient">{data.getIn(["shippingAddress", "name"])}</td>
      <td className="field f-qty">{get_quantity(data.get("products"))}</td>
      <td className="field f-destination">{data.getIn(["shippingAddress", "addressCity"])}, {data.getIn(["shippingAddress", "addressStateProvince"])}, {data.getIn(["shippingAddress", "addressCountryCode"])}</td>
      <td className="field f-warehouse">{warehouse}</td>
      <td className="field f-date">{prepDate}</td>
      <td className="field f-date"><span title={deliveryDateHelp}>{deliveryDate}</span></td>
      <td className="field f-fulfillment"><span className="icon" /><span className="text">{status}</span></td>
      <td className="field f-context"><ContextMenuTrigger active={true} onClick={contextClickFn}/></td>
    </tr>
  )
}

function get_quantity(products) {
  return products.reduce((acc, product) => {
    return acc + product.get("quantity");
  }, 0)
}

export default DeliveryItem;